import React, { useState, useEffect } from "react";
import LogoLoaderSVG from '../assets/LogoLoader.svg';

const LogoLoader = ({ isLoading }) => {
  const [shouldRender, setShouldRender] = useState(true);

  const handleTransitionEnd = () => {
    if (!isLoading) setShouldRender(false);
  };

  useEffect(() => {
    if (isLoading) setShouldRender(true);
  }, [isLoading]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 flex flex-col justify-center items-center bg-white z-[100] transition-opacity duration-700 ${
        isLoading ? "opacity-100 visible" : "opacity-0 invisible"
      }`}
      onTransitionEnd={handleTransitionEnd}
    >
      {/* Logo container with precise sizing */}
      <div className="relative flex justify-center items-center w-[80%] max-w-[400px] lg:max-w-[500px] mb-8 lg:mb-12 z-[101]">
        <img 
          src={LogoLoaderSVG} 
          alt="Loading..." 
          className="w-full h-auto scale-75 lg:scale-90 transition-transform duration-300"
          style={{ maxHeight: '50vh' }}
        />
      </div>

      {/* Optional loading animation */}
      <div className="text-center z-[101] mb-8 lg:mb-12">
        <div className="flex space-x-1 justify-center">
          <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        <p className="text-gray-600 text-sm lg:text-base font-light tracking-wide mt-2">
          Preparing your experience...
        </p>
      </div>

      {/* Bottom white strip overlay */}
      <div className="absolute bottom-0 left-0 w-full h-[20vh] bg-white z-[102]" />
    </div>
  );
};

export default LogoLoader;